import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoboothService } from '../../../services/photobooth.service';

export interface FrameGroupOption {
  themeId: string;
  frameId: string;
  displayName: string;
}

export interface FrameGroupGroup {
  themeId: string;
  frames: FrameGroupOption[];
  expanded?: boolean;
}

@Component({
  selector: 'app-global-frame-group-copy-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './global-frame-group-copy-modal.component.html',
  styleUrls: ['./global-frame-group-copy-modal.component.css']
})
export class GlobalFrameGroupCopyModalComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Output() copyGroup = new EventEmitter<{themeId: string, frameId: string}>();

  globalFrameGroupsGrouped: FrameGroupGroup[] = [];
  isLoading = true;
  selectedGroup: {themeId: string, frameId: string} | null = null;
  @Input() isCopying = false;

  constructor(private photoboothService: PhotoboothService) {}

  async ngOnInit() {
    this.isLoading = true;
    try {
      const groups = await this.photoboothService.getAllFrameGroups(true, 'global', null);
      
      const groupedMap = new Map<string, FrameGroupOption[]>();
      groups.forEach(g => {
        if (!groupedMap.has(g.themeId)) {
          groupedMap.set(g.themeId, []);
        }
        groupedMap.get(g.themeId)!.push({
          themeId: g.themeId,
          frameId: g.frameId,
          displayName: g.name || g.frameId
        });
      });

      this.globalFrameGroupsGrouped = Array.from(groupedMap.entries()).map(([themeId, frames]) => ({
        themeId,
        frames
      }));
    } catch (error) {
      console.error('Error fetching global frame groups', error);
    } finally {
      this.isLoading = false;
    }
  }

  selectFrameGroup(opt: FrameGroupOption) {
    if (this.isCopying) return;
    this.selectedGroup = { themeId: opt.themeId, frameId: opt.frameId };
  }

  onCopy() {
    if (this.selectedGroup) {
      this.copyGroup.emit(this.selectedGroup);
    }
  }

  onClose() {
    if (!this.isCopying) {
      this.close.emit();
    }
  }
}
